module.exports = __webpack_public_path__ + "static/img/jx.8efbef24.jpg";